/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Payload to mark multiple notifications as read
 * @export
 * @interface MarkNotificationsAsReadRequest
 */
export interface MarkNotificationsAsReadRequest {
    /**
     * Array of notification IDs to mark as read
     * @type {Array<number>}
     * @memberof MarkNotificationsAsReadRequest
     */
    notificationIds: Array<number>;
}

/**
 * Check if a given object implements the MarkNotificationsAsReadRequest interface.
 */
export function instanceOfMarkNotificationsAsReadRequest(value: object): value is MarkNotificationsAsReadRequest {
    if (!('notificationIds' in value) || value['notificationIds'] === undefined) return false;
    return true;
}

export function MarkNotificationsAsReadRequestFromJSON(json: any): MarkNotificationsAsReadRequest {
    return MarkNotificationsAsReadRequestFromJSONTyped(json, false);
}

export function MarkNotificationsAsReadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkNotificationsAsReadRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'notificationIds': json['notificationIds'],
    };
}

export function MarkNotificationsAsReadRequestToJSON(json: any): MarkNotificationsAsReadRequest {
    return MarkNotificationsAsReadRequestToJSONTyped(json, false);
}

export function MarkNotificationsAsReadRequestToJSONTyped(value?: MarkNotificationsAsReadRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'notificationIds': value['notificationIds'],
    };
}

